import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import UsersTable from './UsersTable'
import ManageUserScreen from './ManageUserScreen'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((_theme) => ({}))

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={ value !== index }
      id={ `simple-tabpanel-${index}` }
      aria-labelledby={ `simple-tab-${index}` }
      { ...other }
    >
      { value === index && (
        <Box p={ 2 } style={{ minHeight: 750 }}>
          <Paper elevation={ 1 }>
            <Box p={ 3 }>
              { children }
            </Box>
          </Paper>
        </Box>
      ) }
    </Typography>
  )
}

export default function UserTabs(props) {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <>
      <AppBar position="static">
        <Tabs
          value={ value }
          onChange={ handleChange }
          aria-label="Gerenciamento de Usuários"
        >
          <Tab label="Listar" />
          <Tab label="Adicionar" />
        </Tabs>
      </AppBar>
      <TabPanel value={ value } index={ 0 }>
        <UsersTable data={ props.data } />
      </TabPanel>
      <TabPanel value={ value } index={ 1 }>
        <ManageUserScreen />
      </TabPanel>
    </>
  )
}
